import ICDocIcon from "@assets/icons/file-ic-memo.svg";
import CIMIcon from "@assets/icons/file-cim.svg";
import DocRegularIcon from "@assets/icons/file-doc-regular.svg";
import FilledFolderIcon from "@assets/icons/filled-folder.svg";

import { DocumentType } from "@enums/common.enum";
import { openDocumentPage, openDocumentSearch } from "@utils/navigation.util";
import { IDocumentTagResponse } from "@interfaces/responses.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IDocumentTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: IDocumentTagResponse) => void;
  onRemove?: (tag: IDocumentTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function DocumentTag({ data, isDisabled, onAdd, onRemove, withPlusIcon, iconOnly }: Props) {
  let Icon;
  let isTypeDocument = true;

  switch (data.object.type) {
    case DocumentType.IC_MEMO:
      Icon = ICDocIcon;
      break;
    case DocumentType.CIM:
      Icon = CIMIcon;
      break;
    case DocumentType.DOCUMENT:
      Icon = DocRegularIcon;
      break;
    default:
      Icon = FilledFolderIcon;
      isTypeDocument = false;
      break;
  }

  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() =>
        isTypeDocument ? openDocumentSearch(data.object.name) : openDocumentPage(data.object.id)
      }
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <Icon width={18} height={18} className="flex flex-shrink-0" />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.name}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
